const itemsAccordion = document.querySelectorAll('.menu-accordion .item');
const questionsAccordion = document.querySelectorAll('.menu-accordion .item .question');

questionsAccordion.forEach(item =>{

    item.addEventListener('click', () =>{

        const itemParent = item.parentElement;

        if(itemParent.classList.contains('open')){

            itemParent.style.paddingBottom = `0px`
            itemParent.classList.remove('open');

        }else{
            const questionAnswer = itemParent.querySelector('.answer');
            itemParent.style.paddingBottom = `${questionAnswer.offsetHeight+20}px`
            itemParent.classList.add('open');

        }

    })
    
})